import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import './utils/svg-icons';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Suppress specific third-party library warnings that we cannot fix directly
if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    // Filter out Recharts lifecycle warnings since they're from third-party library
    if (
      args[0] &&
      typeof args[0] === 'string' &&
      (args[0].includes('componentWillReceiveProps has been renamed') ||
        args[0].includes('Please update the following components: AreaChart') ||
        args[0].includes('Please update the following components: Area'))
    ) {
      return; // Suppress these specific warnings
    }
    originalWarn.apply(console, args);
  };
}

// eslint-disable-next-line react/jsx-filename-extension
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
